"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountSelectModal = void 0;
const react_1 = __importDefault(require("react"));
const Card_1 = __importDefault(require("react-bootstrap/Card"));
const ListGroup_1 = __importDefault(require("react-bootstrap/ListGroup"));
const Modal_1 = __importDefault(require("react-bootstrap/Modal"));
const BookingDiscount_1 = require("../../../models/BookingDiscount");
const DiscountSelectModal = (props) => {
    var _a;
    function handleDiscountSelected(configDiscount) {
        props.onDiscountSelected(BookingDiscount_1.BookingDiscount.fromConfigDiscount(configDiscount));
    }
    function handleCustomDiscountSelected() {
        const customDiscount = new BookingDiscount_1.BookingDiscount();
        customDiscount.percent = 0;
        props.onDiscountSelected(customDiscount);
    }
    return (react_1.default.createElement(Modal_1.default, { className: "discount-select-modal " + ((_a = props.className) !== null && _a !== void 0 ? _a : ""), show: true, onHide: props.onClose, animation: false, centered: true },
        react_1.default.createElement(Modal_1.default.Header, { closeButton: true },
            react_1.default.createElement(Modal_1.default.Title, null, "Rabatt w\u00E4hlen")),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement(Card_1.default, null,
                react_1.default.createElement(ListGroup_1.default, { variant: "flush" },
                    props.configDiscounts.map((configDiscount, index) => {
                        return (react_1.default.createElement(ListGroup_1.default.Item, { key: configDiscount.title +
                                configDiscount.code +
                                configDiscount.getValue(), action: true, onClick: () => handleDiscountSelected(configDiscount) },
                            react_1.default.createElement("strong", null,
                                configDiscount.getValue(),
                                configDiscount.isPercent() ? "%" : " CHF"),
                            " ",
                            configDiscount.title,
                            react_1.default.createElement("small", { className: "text-secondary" }, configDiscount.code
                                ? ` (Code: "${configDiscount.code}")`
                                : "")));
                    }),
                    react_1.default.createElement(ListGroup_1.default.Item, { action: true, onClick: handleCustomDiscountSelected },
                        react_1.default.createElement("strong", null, "?%"),
                        " Benutzerdefiniert"))))));
};
exports.DiscountSelectModal = DiscountSelectModal;
